module.exports = __webpack_public_path__ + "img/12000.4ca61ea9.jpg";